import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/case-actions.module.scss';
import { ICase } from 'src/types/case';
import DeleteCaseAction from './DeleteCaseAction';

const CaseActionsColumn: React.FunctionComponent<CellProps<ICase>> = ({
    cell: {
        row: { original },
    },
}: CellProps<ICase>) => {
    return (
        <div className={classNames(styles.actions)}>
            <Link to={Router.generate(routes.CASE_EDIT, { id: original.id })} className={'btn btn-info'}>
                <FontAwesomeIcon icon={faPencilAlt} />
            </Link>
            <Link className={'btn btn-info'} to={Router.generate(routes.CASE_CALENDAR, { id: original.id })}>
                <FontAwesomeIcon icon={faCalendarAlt} />
            </Link>

            <DeleteCaseAction data={{ ...original }} />
        </div>
    );
};

export default CaseActionsColumn;
